import { useLang } from "@/context/LanguageContext";
import {
  CalendarCheck,
  Images,
  Languages,
  Search,
  Globe,
  Smartphone,
} from "lucide-react";

const ICONS = [CalendarCheck, Images, Languages, Search, Globe, Smartphone];

export default function Features() {
  const { t } = useLang();

  return (
    <section
      id="features"
      data-testid="features-section"
      className="relative py-24 md:py-32"
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        {/* Heading */}
        <div className="max-w-2xl">
          <span
            data-testid="features-eyebrow"
            className="font-body text-sm uppercase tracking-widest font-bold text-[#22C55E]"
          >
            {t.features.eyebrow}
          </span>
          <h2
            data-testid="features-title"
            className="mt-4 font-heading text-4xl md:text-5xl font-extrabold tracking-tight text-[#064E3B] leading-[1.05]"
          >
            {t.features.title}
          </h2>
          <p
            data-testid="features-subtitle"
            className="mt-5 font-body text-lg md:text-xl text-[#047857] leading-relaxed"
          >
            {t.features.subtitle}
          </p>
        </div>

        {/* Cards grid */}
        <div className="mt-16 grid md:grid-cols-2 lg:grid-cols-3 gap-6">
          {t.features.list.map((f, i) => {
            const Icon = ICONS[i] || CalendarCheck;
            return (
              <div
                key={i}
                data-testid={`feature-card-${i}`}
                className="group relative bg-white rounded-[2rem] border border-[#D1FAE5] p-8 md:p-10 hover:-translate-y-2 hover:shadow-2xl hover:shadow-green-900/10 hover:border-[#22C55E]/40 transition-all duration-500"
              >
                <div className="w-14 h-14 rounded-2xl bg-[#22C55E]/12 flex items-center justify-center mb-6 group-hover:rotate-[-6deg] group-hover:bg-[#22C55E] transition-all duration-300">
                  <Icon
                    className="w-7 h-7 text-[#22C55E] group-hover:text-white transition-colors duration-300"
                    strokeWidth={2}
                  />
                </div>
                <h3 className="font-heading text-2xl font-bold text-[#064E3B]">
                  {f.title}
                </h3>
                <p className="mt-3 font-body text-base text-[#047857] leading-relaxed">
                  {f.desc}
                </p>
                <span
                  aria-hidden
                  className="absolute top-6 right-6 font-heading text-5xl font-black text-[#D1FAE5]/60 select-none"
                >
                  {String(i + 1).padStart(2, "0")}
                </span>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
